import axios from 'axios';
import Cookies from 'js-cookie';
import { HOST_API } from '../config/hosts';

const api = axios.create({
  baseURL: HOST_API,
});

api.interceptors.request.use((config) => {
  const authToken = Cookies.get('AUTH_TOKEN');
  const token = authToken ? JSON.parse(authToken)?.token : null;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
